import React from "react";
import Suraj_K from "./Suraj.jpeg";
import "./blogs.css";

const Suraj = () => {
  return (
    <div className="blog">
      <div className="row blog-row">
        <div className="col-md-4">
          <img
            src={Suraj_K}
            style={{ height: "395px", width: "92%" }}
            alt="Suraj"
          ></img>
        </div>
        <div className="col-md-8">
          <div className="blog-head">
            <h2>Suraj Kumar</h2>
            <small>Godrej Properties Limited</small>
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <div className="row blog-row">
          <div className="col--md-12">
            <h3>Introduction </h3>
            <p>
              Hi everyone, I’m Suraj Kumar, a Y21 BT-CE student, and I’m currently placed at Godrej Properties Limited (GPL). This blog is about my journey from being confused, nervous, and uncertain to finally landing a placement at GPL. I hope it helps anyone who’s going through the same phase.
            </p>
          </div>
        </div>
        {/* <img
          class="blog-image-right"
          src="/placement-postulates/blogs/Utkrash-Srivastava/1.jpg"
          alt="Suraj"
        /> */}

        <div className="row blog-row">
          <div className="col-md-12">
            <h3> Skipping Intern Phase</h3>
            <p>
              Back in my third year, I was in a strange headspace, confused, scared, and unsure about myself. When the Internship Track 2023 came around, I didn’t even register. In my mind, I kept repeating the same thoughts: “I haven’t prepared enough. I don’t have any PORs. I don’t have the right skills. Why would any company even shortlist me?”</p>
              <p>
                With all that self-doubt, I convinced myself to take what seemed like the “safer” option. I decided to go for a dual degree in Economics. My CPI was above 7.5, so I was eligible, and I thought, “Maybe the extra year will give me more time to prepare.” It felt like the practical choice at the time.

            </p>
            <p>
              I even went around asking people for advice, but deep down, I had already made up my mind. And that’s the thing, once you decide something out of fear, no amount of external advice can save you. Looking back, I feel that skipping the internship was the worst decision I made in college.
              </p>
            
            <p>
              Now, don’t get me wrong, I’m not saying a dual or double major is a bad choice. If you genuinely love another subject, you should absolutely go for it. But doing it just to avoid facing challenges, that’s where I went wrong.
            </p>
            <p>
              The biggest realization I had later was this: you’re never really “ready” for interviews. Nobody ever is. You only learn and grow by going through them one by one. That’s why I’d strongly suggest sitting for the internship process, even if you feel underprepared. Internships are one of the best ways to gear yourself up for placements. And if you actually manage to land one, it’s just the cherry on top.
            </p>
            <p>
              Looking back, the lesson is simple: the easier path isn’t always the right one.
            </p>
          </div>
        </div>

        <div className="row blog-row">
          <div className="col-md-12">
            <h3>God's Plan</h3>
            <p>
              Once I had decided to go for a dual degree in Economics, I did my homework. I spoke to seniors who had taken it, gathered all the information I needed, and even started preparing for the upcoming Internship Drive 2024.
            Oh, and I should mention, I used to play cricket. I was part of the institute cricket team since my second year, and that summer, I poured all my time and energy into it. I didn’t think about internships or career-related stuff even once. Looking back, that was another lesson in itself: “Don’t get completely lost in something. Your career should always come first. Hobbies are great and worth pursuing, but don’t lose sight of your long-term goals.”

            </p>
            <p>
              But life had other plans. I didn’t get the dual degree in Economics because my CPI was just 0.04 below the cutoff. At the time, I was shattered. I felt unlucky, frustrated, and honestly, I thought my college life was ruined. I hadn’t prepared for placements, I hadn’t even made a resume once, I was completely clueless about what to do next.
            </p>
            <p>
              That was one of my lowest phases. But here’s where my friends made all the difference. They reminded me of the things I did have, things many others didn’t, and yet those people were confidently sitting for placements. They helped me rebuild the confidence I’d lost. With their support, I started working on projects relevant to the roles I was aiming for and gradually gathered the courage to face the placement season head-on.
            </p>
            <p>
                Now, when I look back, I realize something ironic. If my CPI had been 0.04 higher and I had actually gotten the dual, I might have struggled even more in the long run.
                The biggest takeaway from that phase? During tough times, it’s your friends who keep you afloat and help you steer through the storm.
                </p>
          </div>
        </div>
        <br />
        <br />
        <br />
        {/* <img
          class="blog-image-right"
          src="/placement-postulates/blogs/Utkrash-Srivastava/2.jpg"
          alt="Suraj"
        /> */}
        <div className="row blog-row">
          <div className="col-md-12">
            <h3>Resume Building and Skill</h3>
            <p>
              With the setback behind me, I finally pulled myself together and began working on my resume. Time was short, so I focused on learning DSA, Machine Learning, and Deep Learning. I also picked open electives in ML and Data Mining to strengthen my foundation. For projects, I took inspiration from everywhere, online platforms, seniors, courses, even friends, and gradually built a decent portfolio.

            </p>
            <p>
              After evaluating my preparation and having multiple discussions with seniors, I decided to target roles in Data Science, Data Analysis, and Core profiles. It felt like the right choice since my projects and internships were naturally aligned with these areas. I also followed the placement guide shared by the SPO team, which turned out to be a game-changer. It gave me a clear structure to plan my prep.

            </p>
            <p>
             For DSA, I focused on covering the basics well. Most good data science companies don’t grill you with advanced DSA, they usually stick to easy-to-medium-level problems. Another thing I did (and would recommend to everyone) was sending my resume to multiple seniors and friends for feedback. Every single review helped me refine it further.

            </p>
            <p>
             One golden rule I learned: never add something to your resume that you can’t confidently explain in an interview. It’s better to have fewer, stronger points than to stumble on your own claims.
            My biggest strength was that all my projects and internships were recent. I knew them inside out, so discussing them in interviews became much easier. That gave me the confidence I really needed.

            </p>
            <p>
             Resume ready. Mindset ready. Placement season, here I come!
            </p>
          </div>
        </div>
        {/* <img
          class="blog-image-left"
          src="/placement-postulates/blogs/Utkrash-Srivastava/3.jpg"
          alt="Suraj"
        /> */}
        <div className="row blog-row">
          <div className="col-md-12">
            <h3>Interview Shortlist</h3>
            <p>
             Then came the assessment stage, the real gateway to interviews. To even get shortlisted, you need to perform really well in a company’s test. And trust me, having a solid group of friends makes all the difference here. Surround yourself with people who are both trustworthy and helpful, and if they also happen to be great coders (or even better, have PPOs), it’s a huge bonus.

            </p>
            <p>
              It’s not just coding either. Some companies conduct PPT-making competitions before interviews, Godrej, for example, has one. So being creative with presentations is also a skill worth having.
              At the end of the day, there are two golden rules for getting an interview shortlist:
              
              1. Solve more questions correctly than others.

              2. Make sure your code is original. Never let anyone copy yours, and don’t copy from others either. Plagiarism can cost you everything.
            </p>
          </div>
        </div>

        {/* <div className="row blog-row">
          <div className="col-md-12">
            <h3>Dark Realities in Placement Processes:</h3>
            <p>
              Another important thing: take every test that’s open to you, no matter the role. You really don’t know where your opportunity might come from. I made the mistake of skipping several SDE tests because I thought they weren’t for me, and that’s something I still regret.
            </p>
            <p>
             Also, don’t lose hope when shortlists start rolling out. It’s common to not see your name in the first few, but patience pays off. Keep taking tests, stay consistent, and don’t get frustrated. Once you’ve got a decent number of shortlists and feel confident about cracking at least one interview, you can afford to be selective. At that point, it’s okay to skip some tests for lower-paying jobs, but only if you’re really confident about your chances with the ones you already have.
            </p>
          </div>
        </div> */}
        {/* <img
          class="blog-image-right"
          src="/placement-postulates/blogs/Utkrash-Srivastava/4.jpg"
          alt="Suraj"
        /> */}
        <div className="row blog-row">
          <div className="col-md-12">
            <h3>D-DAY</h3>
            <p>
              My interview journey kicked off with BPCL, a government-owned oil refinery company. I was extremely nervous and underconfident. I genuinely thought I might go blank in front of the panel. But once the interview began, things flowed smoothly. I answered with confidence and walked out feeling like I had cracked it. That interview also helped me overcome a big fear. I realized I could present myself well.
              <br/>
              But then came the shock. I didn’t make it to the next round. When I saw the shortlist, my heart sank. I cried a lot that day, clueless about what had gone wrong. In frustration, I even left a test halfway through and skipped a few others. It was one of those really low moments. Thankfully, my friends Tanvi and Rishi stepped in again, pulling me out of that dark space and motivating me to sit for the next interviews.
               <br/>
              On Day 1.2, I had an SDE interview with Meesho, which didn’t go well. Then came Ola, but that too wasn’t what I’d hoped for. I returned to the hostel with a heavy heart, carrying back-to-back rejections. Still, I knew I couldn’t stop there because Day 2.1 had two big interviews lined up, Kotak Mahindra Bank (for an analyst role) and Godrej (for a core role). Both were among my top targets.
               <br/>
              That evening, I sat down with my resume, going through each point in detail. I researched both companies, their work, their culture, anything that could help me make a stronger impression. The next morning, my two interviews were scheduled back-to-back.
               <br/>
              First up was Kotak Mahindra Bank. It went fairly well, I managed to answer most of their questions, though I got stuck on an SQL problem. Thankfully, I worked through it and solved it in the end.
                <br/>
              Then came the big one, Godrej. I started with my introduction, after which the interviewer asked me indirectly what I knew about GPL. Thanks to my prep the night before, I was able to answer confidently. After that came a series of technical questions on steel, concrete, and construction management. I tackled them calmly, with a small smile on my face (which I feel is very important during interviews.
               <br/>
              I also had a small advantage here. My slot came after 7 or 8 candidates, so I had already asked them about the types of questions being asked. That bit of extra preparation really helped. The interviewer then shifted to my PORs, especially my experience as the cricket captain. He even gave me a case study based on that role. I answered honestly, sharing my real thoughts and experiences.
              <br/>
              By the end of the day, the results came out. Kotak didn’t select me, which was disappointing but not unexpected. Soon after, Godrej’s results were announced, and my name wasn’t there either. I felt crushed. Tanvi and Vaibhav went to the recruiters to ask about me, and they said a few names would be updated later that night. But honestly, by then, I had almost lost hope.
               <br/>
              I went back to my room feeling completely defeated. Only one interview, Axella, was left. I decided that instead of sulking, I’d prepare. That night, I revised DSA concepts, with Dhruv helping me brush up quickly.
               <br/>
              The next day, I went to Hall 13 with just one thought: no matter what, I have to get placed today. While waiting for my interview, Vaibhav suddenly came up to me and said I had received a placement offer from Godrej. For a second, I couldn’t believe it. Then it hit me, and I just hugged him tightly and broke down in tears.
               <br/>
              It was, without a doubt, the best moment of my college life. I hugged Tanvi, Rishi, Harsh, and Pandey, everyone who had been there for me through the ups and downs. Then I called my parents to share the news. All my mom and dad said was, “Shabash beta.” Those two words meant everything.
              <br/>
              On 3rd December, the best day of my life was unlocked.
            </p>
            
            
          </div>
        </div>
        {/* <img
          class="blog-image-right"
          src="/placement-postulates/blogs/Utkrash-Srivastava/5.jpg"
          alt="Suraj"
        /> */}
        <div className="row blog-row">
          <div className="col-md-12">
            <h3>Friends, Hero of this Complete Story</h3>
            <p>
             Now comes the part I want to write straight from my heart. Friends, note this down somewhere: your friends are your lifeline in college.
             <br/>
             In my placement journey, they were there for me at every single step, whenever I faced a setback, took a wrong decision, or felt completely lost. Honestly, I can’t even imagine what my situation would have been if I had gone through this alone. I genuinely don’t think I would have landed this placement without them.
              <br/>
              From the assessments all the way to the moment I got my offer from GPL, they stood by me like a wall. Whenever I needed them, they showed up, no questions asked. They weren’t just friends anymore, they became my family away from home.
               <br/>
              Apart from my closest friends, my wingmates also played a huge role. They helped me with projects for my resume and stood beside me during the company tests. And then there were Tanvi and Vaibhav, two gems. During interviews, they literally ran through Hall 13 carrying my resume from one company to another, scheduling my interviews back-to-back. They never stopped, never once complained, and never even mentioned it later as if to claim credit. For them, my placement wasn’t just my mission, it became our mission.
               <br/>
             I feel incredibly lucky to have had people like them around me. Rishi, Harsh, and Aditya were always there, whether it was for resume-building, test prep, or assignments. They too hold a very special place in my heart. And beyond them, there were many unsung heroes who quietly supported me in ways I can never forget.
              <br/>
              If there’s one thing I’ve truly learned, it’s this: having good friends by your side makes the toughest journey so much easier. Don’t lose them. Value them. They’re the real heroes of my story, and they can be the heroes of yours too.

            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Suraj;
